'use client';

import { ArticleCardGrid } from '@/app_components/ArticleSections/ArticleCards/ArticleCardGrid';
import { StandardHeading } from '@/app_components/ArticleSections/Heading';
import { Carousel } from '@/app_components/ui/Carousel';
import type { ArticlePreviewGrid } from '@/app_lib/types/ArticlePreview';
import { cn } from '@/app_lib/utils/utils';

interface ArticleSectionCarouselProps {
  articles: ArticlePreviewGrid[];
  className?: string;
  displayNum?: number;
  heading?: string;
  hideSeparator?: boolean;
  href?: string;
  nativoCardId?: number;
  priority?: boolean;
  dataCy?: string;
}

export const NativoPlaceholder = ({ nativoCardId }: { nativoCardId: number }) => (
  <div className='snap-start pl-4 md:pl-0 article-card'>
    {/*  TODO: This needs to be updated to work for pages other than topic pages */}
    <ul className={`nativo-topic-${nativoCardId}`}>
      <li className='h-full w-full bg-helper animate-pulse' />
    </ul>
  </div>
);

export const ArticleSectionCarousel = ({
  articles,
  className,
  dataCy,
  displayNum = 4,
  heading,
  hideSeparator = false,
  href,
  nativoCardId,
  priority,
}: ArticleSectionCarouselProps) => {
  if (articles.length === 0) {
    return null;
  }

  return (
    <div
      className={cn('flex flex-col gap-6', className)}
      data-cy={dataCy}
    >
      {heading && <StandardHeading href={href}>{heading}</StandardHeading>}
      <Carousel
        displayNum={displayNum}
        hideSeparator={hideSeparator}
      >
        {articles.map((article, i) => {
          const elements = [
            <ArticleCardGrid
              article={article}
              className='snap-start min-w-0 pl-4 md:pl-0'
              index={i + 1}
              key={article.databaseId}
              priority={priority}
              source='carousel'
            />,
          ];

          if (nativoCardId && i === displayNum - 3) {
            elements.push(<NativoPlaceholder nativoCardId={nativoCardId - 1} />);
          }

          return elements;
        })}
      </Carousel>
    </div>
  );
};
